import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  PICKING_UP,
  ITEM_TYPE_ICON,
  EXPECTATION_ICON,
} from 'constants/new-order-status';
import allocatingSvg from 'public/images/status/allocating.svg';
import schedulingSvg from 'public/images/status/scheduling.svg';
import completedSvg from 'public/images/status/completed.svg';
import cancelledSvg from 'public/images/status/cancelled.svg';
import returnedSvg from 'public/images/status/returned.svg';
import batchedSvg from 'public/images/status/batched.svg';
import driverSvg from 'public/images/status/driver.svg';
import {
  isCompletedStatus,
  isCancelledStatus,
  isPendingStatus,
  isAllocatingStatus,
  isPendingScheduleStatus,
  isFailedStatus,
  isReturnedStatus,
} from 'common/utils/status';

import styles from './status-logo.less';

const StatusLogo = ({
  enlargeIcon,
  status,
  itemTypeId,
  expectationId,
  userType,
}) => {
  const { isSender } = userType;
  const logoSrc = useMemo(
    () => {
      if (isAllocatingStatus(status)) return allocatingSvg;
      if (isPendingScheduleStatus(status)) return schedulingSvg;
      if (isPendingStatus(status)) return batchedSvg;

      if (isReturnedStatus(status)) return returnedSvg;
      if (isCompletedStatus(status)) return completedSvg;
      if (isCancelledStatus(status) || isFailedStatus(status))
        return cancelledSvg;

      if (expectationId in EXPECTATION_ICON)
        return EXPECTATION_ICON[expectationId];

      if (isSender && status === PICKING_UP && itemTypeId in ITEM_TYPE_ICON)
        return ITEM_TYPE_ICON[itemTypeId];

      return driverSvg;
    },
    [status, itemTypeId, isSender, expectationId],
  );

  const iconContainerClassName = cx({
    [styles.iconContainer]: !enlargeIcon,
    [styles.enlargeIconContainer]: enlargeIcon,
  });

  return (
    <div className={iconContainerClassName}>
      <img className={styles.icon} src={logoSrc} alt="status" />
    </div>
  );
};

StatusLogo.propTypes = {
  enlargeIcon: PropTypes.bool,
  status: PropTypes.string.isRequired,
  expectationId: PropTypes.number,
  itemTypeId: PropTypes.number,
  userType: PropTypes.shape({
    isReceiver: PropTypes.bool,
    isSender: PropTypes.bool,
  }).isRequired,
};

StatusLogo.defaultProps = {
  enlargeIcon: false,
  expectationId: 0,
  itemTypeId: 0,
};

export default StatusLogo;
